// Shared progress-stepper configuration for the new Job Poster funnel (epic GO4-1704).
//
// The funnel renders a single SegmentedStepper in the top navigation (see
// components/V2/NavBar), so individual step scenes never render their own. This map is the
// single source of truth: App.js reads it from the current pathname and feeds the navbar.
//
// `total` is the number of progress segments; the per-step value is the number of *filled*
// segments. NOTE: only Next Steps (4/5) is verified against Figma (node 564:606). Steps 1-4
// and 6 are still being built (GO4-1723/1724/1736/1737/1729) — their values are best-guess
// placeholders to confirm against the design as each step lands (a Figma re-pull is currently
// blocked by the View-seat rate limit).

// Filled-segment count keyed by the funnel route's last path segment (slug).
const FILLED_BY_SLUG = {
  role: {
    step: 1, // step 1 — Role (GO4-1723)
    backTo: null,
  },
  'organization-type': {
    step: 2, // step 2 — Organization Type (GO4-1724)
    backTo: 'role',
  },
  'organization-details': {
    step: 3, // step 3 — Organization Details (GO4-1736)
    backTo: 'organization-type',
  },
  'sign-up': {
    step: 4,
    backTo: 'organization-details',
  },
  // step 4 (GO4-1737): slug TBD — add when those steps are built.
  'ready-to-post': {
    step: 5, // step 5 — Next Steps (GO4-1728) — verified 4/5 vs Figma 564:606
    backTo: null,
  },
  persona: {
    step: 6, // step 6 — Persona (GO4-1729)
    backTo: 'ready-to-post',
  },
  'request-consultation': {
    step: 7, // step 6 — Persona (GO4-1729)
    backTo: 'ready-to-post',
  },
};

const FUNNEL_TOTAL = Object.keys(FILLED_BY_SLUG).length;

/**
 * Returns the SegmentedStepper config for a funnel route, or null when the stepper
 * should not be shown (non-funnel routes or steps not yet wired).
 * @param {string} pathname e.g. "/create-account/ready-to-post"
 * @returns {{ current: number, total: number, backTo: string | null } | null}
 */
export const getFunnelStepperConfig = pathname => {
  if (!pathname || !pathname.includes('/create-account')) return null;

  const slug = pathname.split('/').filter(Boolean).pop();
  const current = FILLED_BY_SLUG[slug];
  if (!current) return null;

  return { current: current.step, total: FUNNEL_TOTAL, backTo: current.backTo };
};
